<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" gutter="10px">
      <y-query-item>
        <k-input placeholder="请输入提现申请单号" v-model="para.withdrawNo" clearable></k-input>
      </y-query-item>

      <y-query-item>
        <k-input placeholder="请输入客商名字关键字" v-model="para.customerName" clearable></k-input>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="onChangeDate" :value="pickedTime" format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择创建时间 " style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item slot="right">
        <y-button @click="onBatchCreate">生成对账单</y-button>
        <y-button @click="onBatchVerify">批量审核</y-button>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <y-query-item>
        <k-select placeholder="请选择销售渠道" v-model="para.saleChannelCode" clearable>
          <k-option v-for="(item,index) in arrChannelList" :key="index" :selected="para.saleChannelCode === item.code"
            :value="item.code" :label="item.name">{{item.name}}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择打款方式" v-model="para.remitType" clearable>
          <k-option v-for="(value, key) in objremitType" :key="key" :value="key" :label="value"
            :selected="para.remitType == key">
            {{ value }}
          </k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" v-model="para.status" clearable>
          <k-option v-for="(value, key) in objstatus" :key="key" :value="key" :label="value"
            :selected="para.status == key">
            {{ value }}
          </k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <div style="width: 80px;"></div>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="arrDataList" checkboxKey="id" :selectedRows.sync="selectedRows" :selectedKeys.sync="selectedKeys"
      hasCheckbox :pageIndex="para.pageCurrent" :pageSize="para.pageSize" :height="$root.tableHeightXX"
      :rightFixedNumber="1" :leftFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="arrDataList && arrDataList.length" :current-page.sync="para.pageCurrent"
      :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup :show.sync="isShowPopup" title="提现日志" layout="header,body,close,mask">
      <y-popup-body size="big">
        <div class="mb-2" style="min-height: 300px;">
          <k-table :data="arrLogData" :columns="logColumns"></k-table>
        </div>
      </y-popup-body>
    </k-popup>
    <k-popup bind="v-if" title="拒绝原因" :show.sync="isShowRefuse" @after-ok="onSaveRefuse">
      <y-popup-body size="small">
        <!-- <k-input tag="textarea" style="height: 180px;" v-model="reason" rows="4" block placeholder="请输入拒绝原因"></k-input> -->
        <div class="k-input-section" style="width: 100%;">
          <textarea class="k-textarea k-input--left" style="height: 150px;" rows="4" v-model="reason"
            placeholder="请输入拒绝原因"></textarea>
        </div>
      </y-popup-body>

    </k-popup>
  </y-view>
</template>

<script>
  /**
   * @name: 
   * @description: 提现明细
   * @author: zhaoliubin@yuouhui.com
   * @create: 2020-10-09 14:42:16
   * @update: 2020-10-09 14:42:16
   */
  export default {
    components: {
    },
    props: {
    },
    computed: {
    },
    watch: {
    },
    data() {
      return {
        isShowPopup: false,
        isShowRefuse: false,
        reason: '',
        para: {
          pageCurrent: 1,
          pageSize: 15,
          remitType: '',
          withdrawNo: '',
          saleChannelCode: '',
          startTime: '',
          endTime: '',
          status: '',
        },
        objCurItem: {},
        pickedTime: [],
        editPara: {
          goodsCode: '',
          wscode: '',
        },
        objstatus: {
          0: '待审核',
          '1': '审核成功', 2: '待打款',
          '3': '已提交',
          '4': '已完成', 5: '打款失败', 6: '拒绝'
        },
        objremitType: {
          1: '对私',
          2: '对公',
        },
        total: 0,
        arrDataList: [],
        arrChannelList: [],
        arrGoodsCodeList: [],
        arrDetailList: [],
        isLoading: false,
        selectedRows: [],
        selectedKeys: [],
        customerCodeList: [],
        arrLogData: [],
        logColumns: [
          {
            name: "创建时间",
            field: "createTime",
            style: {
              width: 80,
            },
          },
          {
            name: "创建人",
            field: "createBy",
            style: {
              width: 50,
              whiteSpace: "normal",
            },
          },
          {
            name: "操作",
            field: "description",
            style: {
              width: 80,
              whiteSpace: "normal",
              'word-break': 'break-all',
            },
          },
          {
            name: "内容",
            field: "content",
            style: {
              width: 120,
              whiteSpace: "normal",
              'word-break': 'break-all',
            },
          },
          {
            name: "备注",
            field: "remark",
            style: {
              width: 80,
            },
          },
        ],
      };
    },
    methods: {
      initColumns() {
        return [
          {
            name: '销售渠道',
            field: 'saleChannelName',
            style: {
              width: 100
            }
          },
          {
            name: '对账单号',
            field: 'remitNo',
            style: {
              width: 100,
              'white-space': 'normal',
              'word-break': 'break-all',
            }
          },
          {
            name: '申请提现单号',
            field: 'withdrawNo',
            style: {
              width: 120,
              'white-space': 'normal',
              'word-break': 'break-all',
            }
          },
          {
            name: '申请提现金额（元）',
            field: 'amount',
            style: {
              width: 140,
            },
          },
          {
            name: '打款方式',
            field: '',
            style: {
              width: 80,
            },
            customRender: (row) => {
              return <div>{row.remitType == 1 ? '对私' : '对公'}
              </div>;
            }
          },
          {
            name: '用户姓名',
            field: 'shopMemberName',
            style: {
              width: 80, 'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: '分销角色',
            field: 'shopMemberTypeName',
            style: {
              width: 80, 'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: '客商名称',
            field: 'customerName',
            style: {
              width: 80,
              'white-space': 'normal',
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: '银行名称',
            field: 'bankName',
            style: {
              width: 120,
              'white-space': 'normal',
            },
          },
          {
            name: '开户行',
            field: 'depositBank',
            style: {
              width: 80,
              'white-space': 'normal',
            },
          },
          {
            name: '行号',
            field: 'bankNumber',
            style: {
              width: 80,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: '账户名称',
            field: 'accountName',
            style: {
              width: 100,
              'white-space': 'normal',
            },
          },
          {
            name: '银行账号',
            field: 'bankCardNumber',
            style: {
              width: 120,
              'white-space': 'normal',
              'word-break': 'break-all',
            },
          },
          {
            name: '银行预留手机号',
            field: 'bankReservedPhone',
            style: {
              width: 120
            },
          },
          {
            name: '状态',
            field: 'statusName',
            style: {
              width: 70
            },
          },
          {
            name: '创建时间',
            field: 'createTime',
            style: {
              width: 140
            },
          },
          {
            name: '操作',
            field: '',
            style: {
              width: 120,
              textAlign: 'center'
            },
            customRender: (row) => {
              const btnCheck = (
                <span> <a
                  href="javascript:void(0);"
                  onClick={() => {
                    this.onVerify(row);
                  }}
                >
                  审核&#12288;
                </a>
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      this.onRefuse(row);
                    }}
                  >
                    拒绝&#12288;
                </a>
                </span>

              );
              const btnLog = (
                <a
                  href="javascript:void(0);"
                  onClick={() => {
                    this.onShowLog(row);
                  }}
                >
                  日志
                </a>
              );
              return <div>{row.status == 0 ? btnCheck : ''}{btnLog}</div>;
            }
          }
        ];
      },
      initPageData() {
        //   this.arrDataList = Mock.mock({
        //   'data|5-15': [{
        //     'streamCode|10000-88888': 20,
        //     'orderCode': '@id',
        //     'afterSaleCode': '@integer(200000,500000)',
        //     'type|1': [1, 2, 3],
        //     _name: '@cname',
        //     'shopName': function () {
        //       return this._name + '的门店';
        //     },
        //     'miniShopName': function () {
        //       return this._name + '的微店';
        //     },
        //     'profitSourceType|1': ['价差收益', '门店收益'],
        //     'profitAmount|10-500': 10,
        //     'status|1': [1, 2, 3, 4]
        //   }]
        // }).data;
        // return;
        this.selectedKeys = [];
        this.selectedRows = [];
        let para = this.para;
        this.isLoading = true;
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/page',
          para
        }).then(res => {
          this.arrDataList = res.pageList;
          this.total = res.total;
          this.isLoading = false;
        });
      },
      onChangePageIndex(p) {
        this.para.pageCurrent = p;
        this.initPageData();
      },
      onSearch() {
        this.para.pageCurrent = 1;
        this.initPageData();
      },
      onReset() {
        this.para = this.$options.data().para;
        this.pickedTime = '';
        this.initPageData();
      },
      getChannelList() {
        this.$fetch({
          api: '/nestle-system-back-server/system/sale/channel/page',
          para: {
            pageCurrent: 1,
            pageSize: 10000,
          }
        }).then((res) => {
          this.arrChannelList = res.pageList.filter(c => c.isEnabled);
        }).catch(() => {

        });
      },
      getSearchPara() {
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/option-map',
          para: {}
        }).then(res => {
          this.objstatus = res.statusOptionMap;
          Object.keys(res.remitTypeOptionMap).map(item => {
            if (item != '') {
              this.objremitType[item] = res.remitTypeOptionMap[item];
            }
          })
        }).catch(() => {
        });
      },
      onChangeDate(date) {
        this.para.startTime = date[0];
        this.para.endTime = date[1];
        this.pickedTime = date;
      },
      onBatchCreate() {
        if (this.selectedKeys.length == 0) {
          return this.$root.tip('请先勾选数据');
        }
        console.log(this.selectedKeys);
        this.$fetch({
          api: 'nestle-finance-back-server/withdraw-back/add-remits',
          para: {
            withdrawIds: this.selectedKeys,
          },
          isSuccessTip: true,
        }).then(res => {
          this.initPageData();
        }).catch(() => {

        });
      },
      onBatchVerify() {
        if (this.selectedKeys.length == 0) {
          return this.$root.tip('请先勾选数据');
        }
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/accept',
          para: {
            withdrawIds: this.selectedKeys,
          },
          isSuccessTip: true,
        }).then(res => {
          this.initPageData();
        }).catch(() => {

        });
      },
      onVerify(row) {
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/accept',
          para: { withdrawIds: [row.id] },
          isSuccessTip: true,
        }).then(res => {
          this.initPageData();
        }).catch(() => {

        });
      },
      onRefuse(row) {
        this.reason = '';
        this.isShowRefuse = true;
        this.objCurItem = row;
      },
      onSaveRefuse() {
        if (!this.reason) {
          return this.$root.tip('请输入拒绝原因');
        }
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/reject',
          para: { id: this.objCurItem.id, reason: this.reason },
          isSuccessTip: true,
        }).then(res => {
          this.isShowRefuse = false;
          this.initPageData();
        }).catch(() => {

        });
      },
      onShowLog(row) {
        this.isShowPopup = true;
        this.$fetch({
          api: '/nestle-finance-back-server/withdraw-back/log',
          para: { id: row.id }
        }).then((res) => {
          this.arrLogData = res;
        }).catch(() => {
        });
      },
    },
    created() {
      this.initPageData();
      setTimeout(() => { this.getChannelList(); this.getSearchPara(); }, 100);
    }
  };
</script>

<style lang="postcss" scoped>

</style>